import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../store" // Update the import path according to your project structure

export type Vehicle = {
  id: string
  name: string
  image: string
}

type NewReservationState = {
  vehicles: Vehicle[] | any // todo
  startDate: Date | null
  endDate: Date | null
  startHour: string
  endHour: string
  location: string
  selectedVehicle: string | null
}

const initialState: NewReservationState = {
  vehicles: [
    {
      id: "1",
      name: "Car 1",
      image: "https://via.placeholder.com/150",
    },
    {
      id: "2",
      name: "Car 2",
      image: "https://via.placeholder.com/150",
    },
    {
      id: "3",
      name: "Car 3",
      image: "https://via.placeholder.com/150",
    },
  ], // TODO
  startDate: null,
  endDate: null,
  startHour: "",
  endHour: "",
  location: "",
  selectedVehicle: null,
}

export const newReservationSlice = createSlice({
  name: "newReservation",
  initialState,
  reducers: {
    selectVehicle: (state, action: PayloadAction<string>) => {
      state.selectedVehicle = action.payload
    },

    updateReservationDates: (
      state,
      action: PayloadAction<{
        field: keyof NewReservationState
        value: Date | null
      }>,
    ) => {
      const { field, value } = action.payload
      if (field === "startDate" || field === "endDate") {
        state[field] = value
      }
    },
    updateReservationHours: (
      state,
      action: PayloadAction<{ field: "startHour" | "endHour"; value: string }>,
    ) => {
      const { field, value } = action.payload
      state[field] = value
    },
  },
})

export const { updateReservationDates, updateReservationHours, selectVehicle } =
  newReservationSlice.actions

export const selectVehicles = (state: RootState) => state.newReservation

export default newReservationSlice.reducer
